module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Bold.160e617.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Bold.eot?
// module id = pZ11
// module chunks = 0